export default __webpack_public_path__ + "static/media/asset-zero.97677a0e.png";